// utils
import { trackTemplate } from 'utils/tracking';

/**
 * Slider click
 * @param string text
 */
export function sliderClick(text) {
  return trackTemplate({
    event: 'genericEvent',
    data: {
      category: 'Clicks',
      action: 'Slider',
      label: text,
      value: '0',
    },
  });
}
